<template>
  <v-app>
    <mainNav
      v-if="!routesToHide.includes(this.$router.currentRoute.path)"
    />

    <frontendHeader v-if="this.$route.name == 'frontendPackages'" />

    <v-main>
      <router-view />
    </v-main>
    <frontendFooter v-if="this.$route.name == 'frontendPackages'" />
  </v-app>
</template>

<script>
import mainNav from "./components/nav/mainNav.vue";
import frontendHeader from "./components/nav/frontendHeader.vue";
import frontendFooter from "./components/nav/frontendFooter.vue";

export default {
  name: "App",
  components: {
    mainNav,
    frontendHeader,
    frontendFooter,
  },
  data: () => ({
    routesToHide: ["/login", "/create-account", '/create-account/package-1', '/create-account/package-2', '/create-account/package-3'],
    //
  }),
  mounted() {
    setTimeout(() => {
      document.getElementById("splash-screen").style.display = "none";
    }, 2000); // Change the timeout value to match your app's loading time
  },
};
</script>
